import React from 'react';
import {connect} from 'react-redux';
import equal from 'deep-equal';

import ErrorDisplay from './ErrorDisplay';

class ErrorBoundary extends React.Component {
  state = {error: null, hasError: false};

  componentDidUpdate(prevProps) {
    if (!equal(prevProps.router.route, this.props.router.route)) {
      this.setState({error: null, hasError: false});
    }
  }

  static getDerivedStateFromError(error) {
    return {hasError: true, error};
  }

  componentDidCatch(error) {
    this.setState({error, hasError: true});
  }

  // TODO: future ticket to dynamically get phone # and help center url
  render() {
    if (this.state.hasError) {
      console.error(this.state.error);
      return <ErrorDisplay title="Houston, we have a problem." />;
    }

    // Normally, just render children
    return this.props.children;
  }
}

const mapStateToProps = state => ({
  router: state.router,
});

export default connect(mapStateToProps)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/Common/Error/ErrorBoundary.js